import { memo } from 'react';
import { toast } from 'react-toastify';
import Footer from '../../../../app/Footer';
import thumbsUp from '../../../../assets/ill/Thumbs_up.svg';
import LoadingAnim from '../../../../components/LoadingAnim';
import LogoPatientDynamic from '../../../../components/LogoPatientDynamic';
import PatientOrgContainer from '../../../../patient/hooks/PatientOrgContainer';
import PaTreeHeader from './components/PaTreeHeader';
import { useOnNavChange } from '../../../../hooks/use-on-nav-change';
import { useStaticLocales } from '../../../../admin/hooks/locales/use-static-locale';
import { useTranslations } from '../../../../patient/hooks/use-translations';
import { usePatientTransData } from '../../../hooks/use-patient-trans-data';
import { usePatientLocale } from '../../../hooks/use-patient-locale';

function V2PaAdhocEndPage() {
  const { localeKey, localeCode } = usePatientLocale();
  const { sltStr } = useStaticLocales({ localeCode });
  const [, { t }] = useTranslations({ locale: localeKey });
  const container = PatientOrgContainer.useContainer();

  useOnNavChange({
    block: true,
    onChange: () => {
      toast.info(sltStr({ key: 'msg-cannot-go-back' }), {
        toastId: 'msg-cannot-go-back',
      });
    },
  });

  const titleLabel = t('finish-page-title', {}, { fallbackValue: null });

  const [{ loadingTrans }] = usePatientTransData({
    keys: [],
    locale: localeKey,
  });

  if (loadingTrans) {
    return (
      <div className='flex flex-1 w-full'>
        <LoadingAnim className='h-full p-10 w-full' />
      </div>
    );
  }

  return (
    <PatientOrgContainer.Provider>
      <div className='flex-1 flex-col gap-5 justify-between'>
        <div className='flex-1 flex-col gap-5'>
          <PaTreeHeader showFullBar noBack />

          <div className='px-5'>
            <div className='flex-center'>
              <LogoPatientDynamic logoUrl={container.logoUrl} className='w-9' />
            </div>

            <div className='flex-center flex-col gap-4'>
              <div className='pt-12 pb-6 w-1/3'>
                <img src={thumbsUp} />
              </div>

              <div className='flex-col gap-2 flex-center-y'>
                <h4 className='font-bold sm'>
                  {titleLabel || sltStr({ key: 'finished-title' })}
                </h4>
              </div>
            </div>
          </div>
        </div>

        <div className='hidden flex-none'>
          <Footer />
        </div>
      </div>
    </PatientOrgContainer.Provider>
  );
}

export default memo(V2PaAdhocEndPage);
